import React, { useEffect, useRef, useState } from "react";
import { Box, Stack, Tabs, Tab, Button, Fab, InputBase } from "@mui/material";
import { styled } from "@mui/system";
import Sidebar from "./Sidebar/Sidebar";
import AllPost from "./Tabs/AllPost";
import { useDispatch, useSelector } from "react-redux";
import { handleBookmarkPost, handleFetchPostList, handleLikePost, handleLikeUpdate } from "../../appStore/actions/ArkchatGroup/action";
import VideoPost from "./Tabs/VideoPost";
import PhotosPost from "./Tabs/PhotosPost";
import { serviceTypeName } from "../../utils/constant";
import { getServiceCategory } from "../../appStore/actions/masterData/masterDataAction";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HelperScreen from "../../common/ToolTip/HelperScreen";
import { handleSavePreviewEditPostData, handleSetserviceTypePost } from "../../appStore/actions/AppState/action";
import { showToastMsg } from "../../appStore/actions/global/action";
import AddIcon from "@mui/icons-material/Add";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export const ActionButton = styled(Button)({
  backgroundColor: "#DB0011",
  padding: "4px",
  color: "#fff",
  width: "30px",
  height: "30px",
  minWidth: "unset",
  minHeight: "unset",
  borderRadius: "0.15rem",
  "&:hover": {
    backgroundColor: "#DB0011",
    color: "#fff",
  },
});

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index}>{value === index && <Box>{children}</Box>}</div>
);

const StyledSubHeadingBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F3F3F3",
  marginBottom: "0.5rem",
});

const SearchBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  border: "1px solid #000000",
  backgroundColor: "#FFFFFF",
  height: "30px",
  minHeight: "30px",
  maxHeight: "30px",
  boxSizing: "border-box",
});

const IconButtonBox = styled(Button)({
  minWidth: "30px",
  maxWidth: "30px",
  width: "30px",
  height: "30px",
  minHeight: "30px",
  maxHeight: "30px",
  padding: "4px",
  borderRadius: "0.15rem",
  border: "1px solid #000000",
  backgroundColor: "#FFFFFF",
  color: "#111111",
  boxSizing: "border-box",
  "&:hover": {
    backgroundColor: "#FFFFFF",
  },
});

const actionIconSx = {
  width: "16px",
  height: "16px",
  color: "#000000",
  flexShrink: 0,
};

const ALL_MEDIA_POST_TYPES = "4,5";

const VISIBLE_TAB_TYPE_MAP = {
  0: ALL_MEDIA_POST_TYPES,
  1: serviceTypeName?.Videos,
  2: serviceTypeName?.Photo,
};

const classes = {
  chatBox1: {
    minWidth: "27%",
    maxWidth: "27%",
    backgroundColor: "#F9F8F8",
    height: "calc(100vh - 4rem)",
    "@media (max-width: 1194px)": {
      minWidth: "30%",
      maxWidth: "30%",
      height: "calc(100vh - 50rem)",
    },
  },
  Tabs: {
    minHeight: "38px",
    width: "100%",
    "& .MuiTabs-indicator": {
      backgroundColor: "#183243",
      height: "5px",
    },
    "& .MuiTabs-flexContainer": {
      gap: "3.5rem",
      paddingLeft: "0.8rem",
    },
  },
  tabs: {
    color: "black",
    padding: "0px 0px",
    textTransform: "none",
    minWidth: "unset",
    minHeight: "2.2rem",
    fontSize: "16px",
    fontWeight: 400,
    "&.Mui-selected": {
      color: "black",
    },
  },
};


const ExploreHome = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const exploreContainerRef = useRef(null);
  const [exploreTabValue, setExploreTabValue] = useState(0);
  const [isBookMarkedPost, setBookMarkedPost] = useState(false);
  const [checked, setChecked] = useState([]);
  const [isScrollingToBottom, setIsScrollingToBottom] = useState(false);
  const [isSideBarOpen, setSideBarOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const userData = useSelector((state) => state?.profile?.profileData?.data);
  const exploreDataList = useSelector(
    (state) => state?.arkchatgroup?.exploreDataList
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleViewChange = (event, newValue) => {
    localStorage.removeItem("FilterSwitch");
    localStorage.removeItem("PostType");
    setExploreTabValue(newValue);
  };
  const handleLikeClick = (post_id) => {
    dispatch(handleLikePost(post_id)).then((res) => {
      if (res?.data?.status) {
        dispatch(handleLikeUpdate("", post_id));
      } else {
        dispatch(showToastMsg("Something went wrong !"));
      }
    });
  };
  const handleBookmarkClick = (post_id) => {
    dispatch(handleBookmarkPost(post_id)).then((res) => {
      if (res?.data?.status) {
        dispatch(
          handleFetchPostList({
            type: VISIBLE_TAB_TYPE_MAP[exploreTabValue],
            bookmark: isBookMarkedPost || undefined,
          })
        );
      } else {
        dispatch(showToastMsg("Something went wrong !"));
      }
    });
  };
  const handleEditClick = (data) => {
    dispatch(handleSetserviceTypePost(data?.type));
    dispatch(getServiceCategory(data?.type));
    const createPostData = {
      category: data?.category,
      core_team: {},
      subscriber_id: data?.subscriber_id,
      tags: data?.tags || [],
      topic_id: 0,
      type: data?.type,
      countries: data?.countries || [],
      post_data: data?.postData,
      tagsInput: "",
    };
    const countriesArray = data?.countries?.map((name) => ({ name }));

    const localPreviewData = {
      selectedCategory: data?.category,
      createPostData: createPostData,
      selectedCountries: countriesArray,
      selectedImageList: data?.attachments,
      selectedVideoList: data?.attachments,
      post_id: data?.post_id,
      authorized_seller: data?.authorizedSeller,
      editBrandData: data?.brandInfo,
      editArtistData: data?.artistInfo,
    };
    dispatch(handleSavePreviewEditPostData(localPreviewData));
    localStorage.setItem("post_id", JSON.stringify(data?.id));
    let tabValue;
    if (
      data?.type === serviceTypeName?.Service ||
      data?.type === serviceTypeName?.Art ||
      data?.type === serviceTypeName?.Product
    ) {
      tabValue = 0;
    } else if (data?.type === serviceTypeName?.Photo) {
      tabValue = 1;
    } else if (data?.type === serviceTypeName?.Videos) {
      tabValue = 2;
    }
    localStorage?.setItem("tabValue", tabValue);
    navigate("/post/post-create");
  };
  const handleFilter = (type) => {
    localStorage.setItem("FilterSwitch", true);
    localStorage.setItem("PostType", type);
    setLoading(true);
    dispatch(
      handleFetchPostList({
        page: 1,
        type: type, // Assuming you're passing this as the 'type'
        category: checked?.join(","),
      })
    ).then((res) => {
      setLoading(false);
    });
    setExploreTabValue(
      type === serviceTypeName?.Videos
        ? 1
        : type === serviceTypeName?.Photo
        ? 2
        : 0
    );
  };

  const handlePagination = (page = 1) => {   
    dispatch(
      handleFetchPostList({
        page: page,
        type: VISIBLE_TAB_TYPE_MAP[exploreTabValue],
        category: checked?.join(","),
        fetchOld:true
      })
    );
  };

  const clearFilter = () => {
    if (localStorage.getItem("PostType")) {
      setChecked([]);
      dispatch(
        handleFetchPostList({
          type: VISIBLE_TAB_TYPE_MAP[exploreTabValue],
        })
      );
    }
    localStorage.removeItem("FilterSwitch");
    localStorage.removeItem("PostType");
  };

  const handleGetBookMark = () => {
    setLoading(true);
    dispatch(
      handleFetchPostList({
        bookmark:true,
        type: VISIBLE_TAB_TYPE_MAP[exploreTabValue],
      })
    ).then((res) => {
      setLoading(false);
    });
  };
  
  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      exploreContainerRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 501;
    setIsScrollingToBottom(isAtBottom);
  };

  useEffect(() => {
    if (isScrollingToBottom&&exploreDataList?.posts?.length<exploreDataList?.count) {
      const page = Math.floor(exploreDataList?.posts?.length / 20) + 1;
      handlePagination(page);
    }
  }, [isScrollingToBottom]);

  return (
    <>
      <Box>
        {!userData?.tooltipExploreScreenWeb && (
          <HelperScreen
            title={"How Explore works"}
            updateKey={"tooltip_explore_screen_web"}
            contactSections={[
              { id: "explore-feed", content: [appContent?.KEY154] },
              { id: "explore-browse", content: [appContent?.KEY155] },
              { id: "explore-request", content: [appContent?.KEY156] },
              { heading: appContent?.KEY157, content: [] },
            ]}
          />
        )}
        <Stack direction="row" spacing={1}>
          {isSideBarOpen && (
            <Box sx={classes.chatBox1}>
              <Sidebar
                checked={checked}
                setChecked={setChecked}
                setSideBarOpen={setSideBarOpen}
                isSideBarOpen={isSideBarOpen}
                handleFilter={handleFilter}
                clearFilter={clearFilter}
              />
            </Box>
          )}

          <Box flex={5.2} sx={classes.chatBox3}>
            <Box>
              <StyledSubHeadingBox>
                <Box width={"100%"} display={"flex"} alignItems={"center"}>
                  <Tabs
                    value={exploreTabValue}
                    onChange={handleViewChange}
                    sx={classes.Tabs}
                  >
                    <Tab
                      disableRipple
                      sx={classes.tabs}
                      label="All Posts"
                    />
                    <Tab
                      disableRipple
                      sx={classes.tabs}
                      label="Videos"
                    />
                    <Tab
                      disableRipple
                      sx={classes.tabs}
                      label="Photos"
                    />
                  </Tabs>
                </Box>
              </StyledSubHeadingBox>
              <Stack
                alignItems="center"
                direction="row"
                spacing={1.2}
                paddingX={"8px"}
                marginTop={"0.8rem"}
              >
                <IconButtonBox
                  onClick={() => setSideBarOpen(!isSideBarOpen)}
                  size="small"
                  variant="text"
                >
                  <FilterAltOutlinedIcon sx={actionIconSx} />
                </IconButtonBox>
                <SearchBar>
                  <InputBase
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                    placeholder="Search"
                    sx={{
                      flex: 1,
                      px: 1.5,
                      fontSize: "16px",
                      color: "#000000",
                    }}
                  />
                  <Box
                    sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "100%",
                }}
              >
                <SearchOutlinedIcon sx={{ color: "#183243", fontSize: 20 }} />
              </Box>
            </SearchBar>
                <IconButtonBox
                  onClick={handleGetBookMark}
                  size="small"
                  variant="text"
                >
                  <BookmarkBorderOutlinedIcon sx={actionIconSx} />
                </IconButtonBox>
              </Stack>
              <Box
                ref={exploreContainerRef}
                onScroll={handleScroll}
                bgcolor={"#f1f1f1"}
                mt={"1.2rem"}
                sx={{
                  maxHeight: "75vh",
                  overflow: "auto",
                  "&::-webkit-scrollbar": {
                    width: "0px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "3px",
                  },
                }}
              >
                <TabPanel value={exploreTabValue} index={0}>
                  <AllPost
                    handleLikeClick={handleLikeClick}
                    handleBookmarkClick={handleBookmarkClick}
                    isBookMarkedPost={isBookMarkedPost}
                    handleEditClick={handleEditClick}
                  />
                </TabPanel>
                <TabPanel value={exploreTabValue} index={1}>
                  <VideoPost
                    handleLikeClick={handleLikeClick}
                    handleBookmarkClick={handleBookmarkClick}
                    isBookMarkedPost={isBookMarkedPost}
                    filterSwitchLoading={isLoading}
                    handleEditClick={handleEditClick}
                  />
                </TabPanel>
                <TabPanel value={exploreTabValue} index={2}>
                  <PhotosPost
                    handleLikeClick={handleLikeClick}
                    handleBookmarkClick={handleBookmarkClick}
                    isBookMarkedPost={isBookMarkedPost}
                    filterSwitchLoading={isLoading}
                    handleEditClick={handleEditClick}
                  />
                </TabPanel>
                <Box
                  zIndex={1000}
                  position={"fixed"}
                  bottom={"1rem"}
                  right={"2.4rem"}
                >
                  <Fab
                    onClick={() => navigate("/post")}
                    sx={{
                      bgcolor: "#DB0011",
                      "&:hover": {
                        backgroundColor: "#DB0011",
                      },
                    }}
                    color="primary"
                  >
                    <AddIcon />
                  </Fab>
                </Box>
              </Box>
            </Box>
          </Box>
        </Stack>
      </Box>
    </>
  );
};

export default ExploreHome;
